<template>
	<div>
		<!-- vista con la tabla las solicitudes asignadas -->
		<CRow v-if="showConsult" class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Solicitudes Asignadas
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol>
								<span class="float-left">
									<p>
										Para ver el progreso de los analistas
										asignados a una solicitud debes hacer
										clic en el ícono
										<b><i class="fas fa-eye"></i></b>
									</p>
									<p>
										Para reasignar una solicitud debes hacer
										clic en el ícono
										<b><i class="fas fa-user-tie"></i></b>
									</p>
								</span>
							</CCol>
						</CRow>
						<!-- filtro de la tabla -->
						<CRow>
							<CCol sm="4">
								<CInput
									v-model="filter"
									placeholder="Búscar"
									label="Filtrar"
								></CInput>
							</CCol>
							<CCol sm="4">
								<div role="group" class="form-group">
									<label for="urb"
										>Registros por Página</label
									>
									<multiselect
										v-model="perPage"
										:options="recordsPergPage"
										:searchable="false"
										:close-on-select="true"
										:show-labels="false"
										placeholder="Seleccione"
									>
									</multiselect>
								</div>
							</CCol>
						</CRow>
						<!-- tabla de los envios -->
						<CRow>
							<CCol sm="12">
								<p style="margin-bottom: 30px;">
									<span class="float-right"
										>Cantidad de Envíos:
										<CBadge shape="pill" color="info">
											{{ totalRows }}</CBadge
										>
									</span>
								</p>
								<b-table
									:fixed="true"
									v-if="showTable"
									@filtered="onFiltered"
									:filter="filter"
									stacked="lg"
									striped
									outlined
									hover
									bordered
									:current-page="currentPage"
									:per-page="perPage"
									:items="tableConsult"
									:fields="fieldsTableConsult"
								>
									<!-- width para la columna acciones -->
									<template #table-colgroup="scope">
										<col
											v-for="field in scope.fields"
											:key="field.key"
											:style="{
												width:
													field.key === 'actions'
														? '100px'
														: '',
											}"
										/>
									</template>
									<!-- botones de la seccion acciones -->
									<template #cell(actions)="row">
										<!-- <b-button @click="seeProgress(row.item.idRequest)" title="Re Asignar" pill
                                            variant="primary" size="sm" class="mr-1">
                                            <i class="fas fa-user-tie"></i>
                                        </b-button> -->
										<b-button
											@click="seeProgress(row.item)"
											title="Ver Detalle"
											pill
											variant="info"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-eye"></i>
										</b-button>
									</template>
								</b-table>
							</CCol>
						</CRow>
						<!-- paginacion de la tabla -->
						<CRow>
							<CCol sm="12">
								<b-pagination
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									align="right"
									first-number
									last-number
									pills
								>
									<template #prev-text
										><span class="text-primary"
											>Anterior</span
										></template
									>
									<template #next-text
										><span class="text-success"
											>Siguiente</span
										></template
									>
									<template #page="{ page, active }">
										<b v-if="active">{{ page }}</b>
										<i v-else>{{ page }}</i>
									</template>
								</b-pagination>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<!-- vista para el detalle de la solicitud -->
		<CRow v-if="showViewProgress" class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Progreso de los Analistas
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol sm="12">
								<p>
									A continuación puedes ver el progreso de
									cada analista en las solicitudes asignadas.
								</p>
								<p>
									Si deseas realizar una re asignación
									regeresa a la sección anterior y usa el
									ícoco
									<b><i class="fas fa-user-tie"></i></b>
								</p>
							</CCol>
						</CRow>
						<CRow class="content-center">
							<CCol sm="12">
								<!-- <b-table v-if="tableProgressAnalists.length > 0" stacked="lg" fixed striped -->
								<b-table
									v-if="tableProgressAnalists.length > 0"
									stacked="lg"
									fixed
									striped
									outlined
									hover
									bordered
									:items="tableProgressAnalists"
									:fields="fieldsProgressAnalist"
								>
									<template #cell(actions)="row">
										<b-button
											@click="reAssign(row.item)"
											title="Re Asignar"
											pill
											variant="primary"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-user-tie"></i>
										</b-button>
									</template>
								</b-table>
							</CCol>
						</CRow>
						<CRow class="content-left">
							<CCol sm="6">
								<p>Progreso total de la solicitud</p>
							</CCol>
						</CRow>
						<CRow class="content-left">
							<CCol sm="6">
								<b-progress
									animated
									height="2rem"
									variant="success"
									:max="requestQuatity"
								>
									<b-progress-bar
										:value="valueForProgressBar"
										:label="
											`${(
												(valueForProgressBar /
													requestQuatity) *
												100
											).toFixed(2)}%`
										"
									>
									</b-progress-bar>
								</b-progress>
							</CCol>
						</CRow>
						<CRow class="content-center">
							<CCol sm="12">
								<b-button
									style="margin-top: 15px;"
									@click="goToConsult"
									pill
									variant="info"
									>Regresar</b-button
								>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<!-- vista para la reasignacion -->
		<AssigmentRequest
			v-if="showAssing"
			:title="titleReAsign"
			type-assigment="reassigment"
			:id-request="idRequestForReAsign"
			:id-user="idUserForReAssign"
			:requests-assigned="requestsAssigned"
			:requests-update="requestsUpdate"
			:total-requests-assigned="totalRequestsAssigned"
		/>
	</div>
</template>
<script>
	import requestsAssigned from '../../functions/functionsRequestsAssigned';
	import AssigmentRequest from '../../components/assigmentRequests';
	export default {
		/**Componente del modulo envíos masivos usado para consultar el progreso de los usuarios en las solicitudes asignadas
		 * y reasignar solicitudes a tros usuarios
		 */
		name: 'requestsAssigned',
		title: 'Solicitudes Asignadas | Infoguia',
		components: {
			AssigmentRequest,
		},
		data() {
			return {
				showConsult: true,
				fieldsTableConsult: [
					{
						key: 'categories',
						label: 'Categoría',
					},
					{
						key: 'locations',
						label: 'Localidades',
					},
					{
						key: 'createdDate',
						label: 'Fecha de Creación',
					},
					{
						key: 'sendedDate',
						label: 'Fecha de Envío',
					},
					{
						key: 'status',
						label: 'Estatus',
					},
					{
						key: 'requestRecieve',
						label: 'Solicitudes Recibidas',
					},
					{
						key: 'actions',
						label: 'Acciones',
					},
				],
				tableConsult: [],
				//datos de la paginacion
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				filter: '',
				recordsPergPage: [5, 10, 15, 20],
				showTable: false,
				//datos para la tabla del progreso por analista
				fieldsProgressAnalist: [
					{
						key: 'name',
						label: 'Analista',
					},
					{
						key: 'quantityAssigned',
						label: 'Asignadas',
					},
					{
						key: 'quantityPending',
						label: 'Pendientes por Procesar',
					},
					{
						key: 'quantityInProcess',
						label: 'En Proceso',
					},
					{
						key: 'quantityProcess',
						label: 'Procesadas',
					},
					{
						key: 'actions',
						label: 'Acciones',
					},
				],
				tableProgressAnalists: [],
				showViewProgress: false,
				//datos para la barra de progreso
				requestQuatity: 0,
				maxPercentage: 100,
				//total de solicitudes completadas para el porcentaje
				valueForProgressBar: 0,
				//datos para las asignaciones
				showAssing: false,
				idRequestForReAsign: 0,
				idUserForReAssign: 0,
				requestsAssigned: 0,
				requestsUpdate: 0,
				totalRequestsAssigned: 0,
				titleReAsign: 'Reasignar Solicitudes',
			};
		},
		created() {
			this.loadData();
		},
		methods: {
			onFiltered(filteredItems) {
				// Metodo para actualizar el numero de paginas en el paginado a medida que se filtra
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			goToConsult() {
				//this.quantityToAsing = 0
				this.showConsult = true;
				this.showViewProgress = false;
				this.tableProgressAnalists = [];
				this.requestQuatity = 0;
				this.valueForProgressBar = 0;
				this.totalRequestsAssigned = 0;
			},
			seeProgress(request) {
				let loader = this.$loading.show();
				let idRequest = request.idRequest;
				this.requestQuatity = request.requestRecieve;
				requestsAssigned
					.getProgress(idRequest)
					.then((response) => {
						this.requestsUpdate = request.requestRecieve;
						for (let index = 0; index < response.length; index++) {
							this.totalRequestsAssigned =
								this.totalRequestsAssigned +
								response[index].quantityAssigned;
							this.tableProgressAnalists[index] = {
								name: '',
								quantityAssigned:
									response[index].quantityAssigned,
								quantityPending:
									response[index].quantityPending,
								quantityInProcess:
									response[index].quantityInProcess,
								quantityProcess:
									response[index].quantityProcess,
								idRequest: idRequest,
								idUser: response[index].idusers,
								// 'sended': response[index].sendingDate == null ? false : true,
								// //'codLocation': response[index].locationSent,
								// 'idRequest': response[index].idRequests,
								// 'idstatus': response[index].idstatus,
								// //'_rowVariant': response[index].idstatus == 8 ? 'success' : '',
								// 'status': response[index].status.name
							};
							requestsAssigned
								.getSpecificUser(response[index].idusers)
								.then((responseUser) => {
									this.tableProgressAnalists[index].name =
										responseUser[0].name;
								})
								.catch((errorUser) => {
									console.log(errorUser);
								});
						}
						this.valueForProgressBar = this.tableProgressAnalists.reduce(
							(accumulator, currentValue) =>
								accumulator +
								Number(currentValue.quantityProcess),
							0
						);
						this.showConsult = false;
						this.showViewProgress = true;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			reAssign(request) {
				this.showAssing = true;
				this.showViewProgress = false;
				this.idRequestForReAsign = request.idRequest;
				this.idUserForReAssign = request.idUser;
				this.requestsAssigned = request.quantityAssigned;
				this.titleReAsign = 'Reasignar Solicitudes de ' + request.name;
			},
			loadData() {
				let loader = this.$loading.show();
				requestsAssigned
					.getAssigneds()
					.then((response) => {
						this.totalRows = response.length;
						for (let index = 0; index < response.length; index++) {
							this.tableConsult[index] = {
								categories:
									response[index].categoria.nombrecategoria,
								locations: 'Nacional',
								createdDate: response[index].created_at,
								sendedDate:
									response[index].sendingDate == null
										? 'Por ser Enviado'
										: response[index].sendingDate,
								requestRecieve: response[index].requestsUpdate,
								sended:
									response[index].sendingDate == null
										? false
										: true,
								//'codLocation': response[index].locationSent,
								idRequest: response[index].idRequests,
								idstatus: response[index].idstatus,
								//'_rowVariant': response[index].idstatus == 8 ? 'success' : '',
								status: response[index].status.name,
							};
							if (response[index].locationSent == 'S') {
								let statesStrin = '';
								for (
									let indexStates = 0;
									indexStates <
									response[index].estados.length;
									indexStates++
								) {
									statesStrin +=
										response[index].estados[indexStates]
											.nombreestado + ', ';
									this.tableConsult[
										index
									].locations = statesStrin
										.trim()
										.slice(0, -1);
								}
							} else if (response[index].locationSent == 'C') {
								let citiesString = '';
								for (
									let indexCities = 0;
									indexCities <
									response[index].ciudades.length;
									indexCities++
								) {
									citiesString +=
										response[index].ciudades[indexCities]
											.nombreciudad + ', ';
									this.tableConsult[
										index
									].locations = citiesString
										.trim()
										.slice(0, -1);
								}
							} else if (response[index].locationSent == 'U') {
								let urbString = '';
								for (
									let indexUrb = 0;
									indexUrb <
									response[index].urbanizations.length;
									indexUrb++
								) {
									urbString +=
										response[index].urbanizations[indexUrb]
											.nameUrbanization + ', ';
									this.tableConsult[
										index
									].locations = urbString.trim().slice(0, -1);
								}
							}
						}
						if (this.tableConsult.length > 0) {
							this.showTable = true;
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
		},
	};
</script>
